import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/icons/PlusIcon.tsx
var r = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19Z",
		fill: "currentColor"
	})
}), i = {
	12: {
		Artwork: r,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				d: "M8.00049 2.5835C8.41455 2.58367 8.75049 2.91939 8.75049 3.3335V7.25049H12.6665C13.0807 7.25049 13.4165 7.58627 13.4165 8.00049C13.4163 8.41455 13.0806 8.75049 12.6665 8.75049H8.75049V12.6665C8.75049 13.0806 8.41455 13.4163 8.00049 13.4165C7.58627 13.4165 7.25049 13.0807 7.25049 12.6665V8.75049H3.3335C2.91939 8.75049 2.58367 8.41455 2.5835 8.00049C2.5835 7.58627 2.91928 7.25049 3.3335 7.25049H7.25049V3.3335C7.25049 2.91928 7.58627 2.5835 8.00049 2.5835Z",
				fill: "currentColor"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: r,
		width: 20,
		height: 20
	},
	24: {
		Artwork: r,
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, tone: r = "default", className: a, ...o }) => /* @__PURE__ */ n(e, {
	source: i[t],
	monochrome: !0,
	className: ["pf-icon-" + r, a].filter(Boolean).join(" "),
	...o
});
//#endregion
export { a as PlusIcon };
